import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useAmeUpTax = () => {
  const calculateAmeUpTax = useCallback(async (
    installmentId: number,
    cardBrand: string,
    supplierIds: string[]
  ): Promise<{ success: boolean; taxRate?: number; error?: string }> => {
    try {
      const { data, error } = await supabase
        .rpc('ameup_tax', {
          installment_id: installmentId,
          card_brand: cardBrand,
          supplier_ids: supplierIds
        });

      if (error) {
        console.error('Error calculating AmeUp tax:', error);
        return { success: false, error: error.message };
      }

      return { success: true, taxRate: data || 0 };
    } catch (error: any) {
      console.error('Error calling ameup_tax function:', error);
      return { success: false, error: error.message || 'Unknown error' };
    }
  }, []);

  return {
    calculateAmeUpTax
  };
};